import api from './axios';

export const adminApi = {
  getStats: () => api.get('/dashboard/stats'),
};

export const meetingApi = {
  create: (data) => api.post('/meetings', data),
  getAll: () => api.get('/meetings'),
  getByReportId: (reportId) => api.get(`/meetings/by-report/${reportId}`),
};
